export const emailValidation = (emailText) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(emailText);
};

export const passwordValidation = (passwordText) => {
  const minLengthRegex = /.{8,}/;
  return minLengthRegex.test(passwordText);
};

export const phoneNumberValidation = (phoneNumber) => {
  // const phoneNumberRegex = /^\+(\d{2})\d{10}$|^\+91\d{10}$/;
  const phoneNumberRegex = /^\+?\d{10}$/;
  return phoneNumberRegex.test(phoneNumber);
};

export function validateName(name) {
  if (!name.trim()) {
    return false; // Check if the field is empty
  }
  const namePattern = /^[A-Za-z\s]+$/;
  return namePattern.test(name);
}

export function validateShopName(shopName) {
  if (!shopName.trim()) {
    return false; // Check if the field is empty
  }
  const shopNamePattern = /^[A-Za-z0-9\s\-\']+$/;
  return shopNamePattern.test(shopName);
}

const validTLDs = [
  "com",
  "net",
  "org",
  "io",
  "edu",
  "gov",
  "co",
  "us",
  "uk",
  "info",
  "biz",
  "store",
];
const commonDomains = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "techstorevi.com",
  "sthanic.com",
];

export function validateEmail(email) {
  console.log("email", email);

  if (!email) return false;

  email = email.trim();

  // validate the general email format
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailPattern.test(email)) return false;

  const [localPart, domainPart] = email.split("@");
  if (!domainPart) return false;

  const domainParts = domainPart.split(".");
  const tld = domainParts[domainParts.length - 1].toLowerCase();

  if (!validTLDs.includes(tld)) return false;

  if (!commonDomains.includes(domainPart.toLowerCase())) {
    return false;
  }

  return true;
}

export function validatePhoneNumber(phoneNumber) {
  if (!phoneNumber.trim()) {
    return false;
  }
  const phonePattern = /^\d{10}$/;
  return phonePattern.test(phoneNumber);
}

export function validateDropdown(dropDownValue) {
  if (!dropDownValue.trim()) {
    return false;
  }
  return true;
}

export function validateDropdownForArray(dropDownArrayValue) {
  if (dropDownArrayValue.length === 0) {
    return false;
  }
  return true;
}
export function validateDOB(dob) {
  if (!dob || isNaN(new Date(dob))) {
    return false;
  }
  return true;
}
export function validateDate(date) {
  if (!date || isNaN(new Date(date))) {
    return false;
  }
  return true;
}
export function validateAadhar(aadhar) {
  if (!aadhar.trim()) {
    return false;
  }
  const aadharPattern = /^\d{12}$/;
  return aadharPattern.test(aadhar);
}

export function validatePAN(pan) {
  if (!pan.trim()) {
    return false;
  }
  const panPattern = /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/;
  return panPattern.test(pan);
}

export function validateGST(gst) {
  if (!gst.trim()) {
    return false;
  }
  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[0-9A-Z]{1}$/;
  return gstPattern.test(gst);
}

export function validateCountry(country) {
  if (!country.trim()) {
    return false;
  }
  const countryPattern = /^[A-Za-z\s]+$/;
  return countryPattern.test(country);
}

export function validateState(state) {
  if (!state.trim()) {
    return false;
  }
  const statePattern = /^[A-Za-z\s]+$/;
  return statePattern.test(state);
}

export function validateCity(city) {
  if (!city.trim()) {
    return false;
  }
  const cityPattern = /^[A-Za-z\s]+$/;
  return cityPattern.test(city);
}

export function validateStreet(street) {
  if (!street.trim()) {
    return false;
  }
  const streetPattern = /^[A-Za-z0-9\s,.\-#\\/]+$/;
  return streetPattern.test(street);
}

export function validateLandmark(landmark) {
  if (!landmark.trim()) {
    return false;
  }
  //const landmarkPattern = /^[A-Za-z0-9\s,.\-#]+$/;
  // const landmarkPattern =
  //   /^[A-Za-z0-9\s,.\-#\+]+(?:,?\s?[A-Za-z0-9\s]+)*(\s\d{6})?$/;
  // return landmarkPattern.test(landmark);
  return true;
}

export function validatePincode(pincode) {
  if (!pincode.trim()) {
    return false;
  }
  const pincodePattern = /^[0-9]{6}$/;
  return pincodePattern.test(pincode);
}

export function validateLicenseNumber(licenseNo) {
  if (!licenseNo.trim()) {
    return false;
  }
  // Regex pattern for a license number in the format of 3 letters followed by 5 digits (e.g., ABC12345)
  const licenseNumberPattern = /^[A-Za-z]{3}[0-9]{5}$/;
  return licenseNumberPattern.test(licenseNo);
}

export function validateBikeNumber(bikeNo) {
  if (!bikeNo.trim()) {
    return false;
  }
  // Regex for bike number format: 2 letters, 2 digits, 2 letters, 4 digits (e.g., Ap12AB1234)
  const bikeNumberPattern = /^[A-Za-z]{2}\d{2}[A-Za-z]{2}\d{4}$/;
  return bikeNumberPattern.test(bikeNo);
}

export function validateAccountNumber(accountNumber) {
  if (!accountNumber.trim()) {
    return false; // Check if the field is empty
  }
  const accountNumberPattern = /^\d{9,18}$/;
  return accountNumberPattern.test(accountNumber);
}

export function validateIfscCode(ifscCode) {
  if (!ifscCode.trim()) {
    return false; // Check if the field is empty
  }
  const ifscCodePattern = /^[A-Za-z]{4}0\d{6}$/; //ex:SBIN0001234 (valid) first 4 letters 5 th is 0 next 6 numbers
  return ifscCodePattern.test(ifscCode);
}

export function validateFacebookUrl(url) {
  return /facebook\.com/i.test(url);
}

export function validateLinkedInUrl(url) {
  return /linkedin\.com/i.test(url);
}
